/* import __COLOCATED_TEMPLATE__ from './url-value.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();